



































































































































































































































































































































































































































































































import { localISODate } from "@/utils/localDate";
import { Component, Prop, Vue } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import { storePersetujuanAnestesi } from "@/store/modules/PersetujuanAnestesiStore";
import PersetujuanAnestesiSvc from "@/services/PersetujuanAnestesi";
import { userModule } from "@/store/modules/user";
import { alasanTtdMengunciHapus, slotTandaTanganDokumen } from "@/utils/hapusSetelahTtd";
import { appModule } from "@/store/modules/app";
import { storeDokter } from "@/store/modules/dokter";
import { storePasien } from "@/store/modules/pasien";

@Component({
  components: {
    CardModalTtd
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class CardPersetujuanAnestesi extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  showForm = false;
  isEditing = false;
  selectedItem: any = null;
  modalTtd = false;
  modalPenyetuju = false;
  modalSaksiKeluarga = false;
  signRole = "";
  markPenyetujuNama = "";
  markSaksiKeluargaNama = "";
  deleting = false;
  saving = false;
  formValid = false;
  menuTanggal = false;
  menuJam = false;
  panels: number[] = [0, 1, 2, 3, 4];

  form: any = this.getEmptyForm();

  tableHeaders = [
    { text: "Tanggal", value: "tgl_tanda_tangan", width: "120" },
    { text: "Jenis Anestesi", value: "jenis_anestesi", width: "140" },
    { text: "ASA", value: "asa_status", width: "100" },
    { text: "Keputusan", value: "is_setuju", width: "100" },
    { text: "Status TTD", value: "status_ttd", width: "120" },
  ];

  jenisKelaminOptions = [
    { text: "Laki-laki", value: "L" },
    { text: "Perempuan", value: "P" },
  ];

  hubunganOptions = [
    { text: "Diri sendiri", value: "diri_sendiri" },
    { text: "Suami", value: "suami" },
    { text: "Istri", value: "istri" },
    { text: "Anak", value: "anak" },
    { text: "Orang tua", value: "orang_tua" },
    { text: "Kakak/Adik", value: "kakak_adik" },
    { text: "Wali", value: "wali" },
  ];

  asaOptions = [
    { text: "ASA 1 - Pasien sehat", value: 1 },
    { text: "ASA 2 - Penyakit sistemik ringan", value: 2 },
    { text: "ASA 3 - Penyakit sistemik berat", value: 3 },
    { text: "ASA 4 - Penyakit sistemik berat mengancam jiwa", value: 4 },
    { text: "ASA 5 - Moribund", value: 5 },
    { text: "ASA 6 - Mati batang otak (donor organ)", value: 6 },
  ];

  mounted() {
    storePersetujuanAnestesi.getByRegister(this.register);
    if (!storeDokter.listAll.length) {
      storeDokter.act_dokter_all();
    }
  }

  getEmptyForm() {
    return {
      penerima_nama: "",
      penerima_jenis_kelamin: "",
      penerima_alamat: "",
      hubungan_pasien: "",
      asa_status: null,
      asa_emergency: false,
      jenis_anestesi: "",
      pengelolaan_nyeri: "",
      is_setuju: null,
      dr_anestesi_id: null,
      penyetuju_nama: "",
      tempat_tanda_tangan: "Bantul",
      tgl_tanda_tangan: localISODate(),
      jam_tanda_tangan: new Date().toTimeString().substr(0, 5),
    };
  }

  get loading() { return storePersetujuanAnestesi.loading; }
  get items() { return storePersetujuanAnestesi.items; }
  get stateuser() { return userModule.user; }
  get dokterList() { return storeDokter.listAll; }

  get pasienNama() {
    return storePasien.identitasPasien?.nama || '';
  }

  get canCreate() {
    if (this.readOnly) return false;
    return userModule.canAccessForm("persetujuan_anestesi", "create");
  }

  get canEdit() {
    if (this.readOnly) return false;
    if (!userModule.canAccessForm("persetujuan_anestesi", "edit")) return false;
    return this.selectedItem && !this.selectedItem.is_locked;
  }

  get canDelete() {
    if (this.readOnly) return false;
    if (!userModule.canAccessForm("persetujuan_anestesi", "edit")) return false;
    if (!this.selectedItem) return false;
    return this.lolosGerbangTtdHapus;
  }

  get lolosGerbangTtdHapus() {
    if (!this.selectedItem) return false;
    return !alasanTtdMengunciHapus(
      this.selectedItem.creator_user_id,
      [
        { ditandatangani: this.selectedItem.signed_penyetuju, penandaTanganId: null },
        { ditandatangani: this.selectedItem.signed_saksi_rs, penandaTanganId: this.selectedItem.saksi_rs?.id },
        { ditandatangani: this.selectedItem.signed_saksi_keluarga, penandaTanganId: null },
        ...slotTandaTanganDokumen(this.selectedItem.signed_dr_anestesi, this.selectedItem.signature_dr_anestesi)
      ],
      this.stateuser?.id
    );
  }

  get canSignDrAnestesi() {
    if (this.readOnly) return false;
    if (!userModule.canAccessForm("persetujuan_anestesi", "sign")) return false;
    if (!this.selectedItem || this.selectedItem.signed_dr_anestesi) return false;
    return this.selectedItem.dr_anestesi?.id == this.stateuser?.id;
  }

  get canSignSaksiRs() {
    if (this.readOnly) return false;
    if (!this.selectedItem || this.selectedItem.signed_saksi_rs) return false;
    if (this.selectedItem.saksi_rs && this.selectedItem.saksi_rs.id != this.stateuser?.id) return false;
    return true;
  }

  get canMarkPenyetuju() {
    if (this.readOnly) return false;
    return this.selectedItem && !this.selectedItem.signed_penyetuju;
  }

  get canMarkSaksiKeluarga() {
    if (this.readOnly) return false;
    return this.selectedItem && !this.selectedItem.signed_saksi_keluarga;
  }

  get canDeleteState() {
    if (this.readOnly) return false;
    if (!this.selectedItem) return false;
    return this.lolosGerbangTtdHapus;
  }

  get canEditState() {
    if (this.readOnly) return false;
    return this.selectedItem && !this.selectedItem.is_locked;
  }

  get canSignDrAnestesiState() {
    if (this.readOnly) return false;
    if (!this.selectedItem || this.selectedItem.signed_dr_anestesi) return false;
    return this.selectedItem.dr_anestesi?.id == this.stateuser?.id;
  }

  hubunganLabel(value: string) {
    const opt = this.hubunganOptions.find(o => o.value === value);
    return opt ? opt.text : value;
  }

  onHubunganChange(val: string) {
    if (val === "diri_sendiri") {
      const pasien = storePasien.identitasPasien;
      if (pasien) {
        this.form.penerima_nama = pasien.nama || "";
        // jk bisa berisi "Laki-laki"/"Perempuan" atau "L"/"P"
        const jk = (pasien.jk || "").toUpperCase();
        this.form.penerima_jenis_kelamin = jk.startsWith("L") ? "L" : jk.startsWith("P") ? "P" : "";
        this.form.penerima_alamat = pasien.alamat || "";
        this.form.penyetuju_nama = pasien.nama || "";
      }
    }
  }

  // ============ LIST ============

  selectItem(item: any) {
    this.selectedItem = item;
  }

  // ============ FORM ============

  openCreateForm() {
    this.form = this.getEmptyForm();
    this.showForm = true;
  }

  startEdit() {
    const c = this.selectedItem;
    this.form = {
      penerima_nama: c.penerima_nama || "",
      penerima_jenis_kelamin: c.penerima_jenis_kelamin || "",
      penerima_alamat: c.penerima_alamat || "",
      hubungan_pasien: c.hubungan_pasien || "",
      asa_status: c.asa_status,
      asa_emergency: c.asa_emergency,
      jenis_anestesi: c.jenis_anestesi || "",
      pengelolaan_nyeri: c.pengelolaan_nyeri || "",
      is_setuju: c.is_setuju,
      dr_anestesi_id: c.dr_anestesi?.id || null,
      penyetuju_nama: c.penyetuju_nama || "",
      tempat_tanda_tangan: c.tempat_tanda_tangan || "Bantul",
      tgl_tanda_tangan: c.tgl_tanda_tangan || localISODate(),
      jam_tanda_tangan: c.jam_tanda_tangan || new Date().toTimeString().substr(0, 5),
    };
    this.isEditing = true;
  }

  cancelForm() {
    this.showForm = false;
    this.isEditing = false;
    this.form = this.getEmptyForm();
  }

  async simpan() {
    this.saving = true;
    try {
      const payload = {
        register_id: this.register,
        pasien_rm: this.rm,
        ...this.form,
        pengelolaan_nyeri: this.form.pengelolaan_nyeri || null,
      };

      let resp;
      if (this.isEditing && this.selectedItem) {
        resp = await PersetujuanAnestesiSvc.update(this.selectedItem.id, payload);
      } else {
        resp = await PersetujuanAnestesiSvc.create(payload);
      }

      if (resp.data.status == "1") {
        appModule.NoticeDelay("Persetujuan Anestesi berhasil disimpan");
        this.showForm = false;
        this.isEditing = false;
        this.selectedItem = null;
        this.form = this.getEmptyForm();
        storePersetujuanAnestesi.getByRegister(this.register);
      }
    } finally {
      this.saving = false;
    }
  }

  // ============ TANDA TANGAN DIGITAL ============

  openTtd(role: string) {
    this.signRole = role;
    this.modalTtd = true;
  }

  async passTtd(password: string) {
    const signFns: Record<string, Function> = {
      saksi_rs: PersetujuanAnestesiSvc.signSaksiRs,
      dr_anestesi: PersetujuanAnestesiSvc.signDrAnestesi,
    };

    const labels: Record<string, string> = {
      saksi_rs: "Saksi RS",
      dr_anestesi: "Dokter Anestesi",
    };

    const fn = signFns[this.signRole];
    if (!fn) return;

    const resp = await fn(this.selectedItem.id, { password });

    if (resp.data.status == "1") {
      this.modalTtd = false;
      appModule.NoticeDelay(`Berhasil Tanda Tangan ${labels[this.signRole]}`);
      appModule.addMsgTtd("");
      this.selectedItem = null;
      storePersetujuanAnestesi.getByRegister(this.register);
    } else {
      appModule.addMsgTtd(resp.data.message);
      this.modalTtd = true;
    }
  }

  // ============ TANDA MANUAL ============

  openMarkPenyetuju() {
    this.markPenyetujuNama = this.selectedItem?.penyetuju_nama || "";
    this.modalPenyetuju = true;
  }

  async submitMarkPenyetuju() {
    const resp = await PersetujuanAnestesiSvc.markPenyetuju(this.selectedItem.id, {
      penyetuju_nama: this.markPenyetujuNama,
    });

    if (resp.data.status == "1") {
      this.modalPenyetuju = false;
      appModule.NoticeDelay("Berhasil menandai Yang Menyetujui");
      this.selectedItem = null;
      storePersetujuanAnestesi.getByRegister(this.register);
    }
  }

  openMarkSaksiKeluarga() {
    this.markSaksiKeluargaNama = this.selectedItem?.saksi_keluarga_nama || "";
    this.modalSaksiKeluarga = true;
  }

  async submitMarkSaksiKeluarga() {
    const resp = await PersetujuanAnestesiSvc.markSaksiKeluarga(this.selectedItem.id, {
      saksi_keluarga_nama: this.markSaksiKeluargaNama,
    });

    if (resp.data.status == "1") {
      this.modalSaksiKeluarga = false;
      appModule.NoticeDelay("Berhasil menandai Saksi Keluarga");
      this.selectedItem = null;
      storePersetujuanAnestesi.getByRegister(this.register);
    }
  }

  // ============ OTHER ============

  cetakPdf() {
    PersetujuanAnestesiSvc.print(this.selectedItem.id);
  }

  async remove() {
    if (!this.canDeleteState) return;
    const q = confirm("Anda yakin akan menghapus Persetujuan Anestesi ini?");
    if (q && !this.deleting) {
      this.deleting = true;
      try {
        const resp = await PersetujuanAnestesiSvc.destroy(this.selectedItem.id);
        if (resp?.status == 1) {
          appModule.NoticeDelay(resp.message);
          this.selectedItem = null;
          storePersetujuanAnestesi.getByRegister(this.register);
        }
      } finally {
        this.deleting = false;
      }
    }
  }
}
